import { render, staticRenderFns } from "./SearchResultsItem.vue?vue&type=template&id=46bc5b39&scoped=true&"
import script from "./SearchResultsItem.vue?vue&type=script&lang=ts&"
export * from "./SearchResultsItem.vue?vue&type=script&lang=ts&"
import style0 from "./SearchResultsItem.vue?vue&type=style&index=0&id=46bc5b39&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46bc5b39",
  null
  
)

export default component.exports